export const identifyUser = user => {
  if (!window.FS) return

  window.setTimeout(() => {
    window.FS.identify(user.id, {
      email: user.email,
      displayName: user.name,
    })
  }, 0)
}
